import React from 'react';
import { CakeIcon, ShoppingBagIcon, HeartIcon } from 'lucide-react';
export function IdealForSection() {
  return <section className="py-12 mb-12" data-id="element-187">
      <div className="max-w-3xl mx-auto" data-id="element-188">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-amber-900 mb-8" data-id="element-189">
          Ideal Para
        </h2>
        <p className="text-lg text-amber-800 text-center font-medium mb-8" data-id="element-190">
          ¿Quién Puede Beneficiarse de Este Método?
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-191">
          <div className="bg-white p-6 rounded-lg shadow-sm flex flex-col items-center text-center" data-id="element-192">
            <div className="bg-amber-100 p-4 rounded-full mb-4" data-id="element-193">
              <CakeIcon size={32} className="text-amber-600" data-id="element-194" />
            </div>
            <h3 className="text-lg font-bold text-amber-900 mb-2" data-id="element-195">
              Celebraciones Especiales
            </h3>
            <p className="text-gray-700" data-id="element-196">
              Cumpleaños y celebraciones especiales.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm flex flex-col items-center text-center" data-id="element-197">
            <div className="bg-amber-100 p-4 rounded-full mb-4" data-id="element-198">
              <ShoppingBagIcon size={32} className="text-amber-600" data-id="element-199" />
            </div>
            <h3 className="text-lg font-bold text-amber-900 mb-2" data-id="element-200">
              Emprendedores
            </h3>
            <p className="text-gray-700" data-id="element-201">
              Emprendedores que quieran vender tortas caseras con calidad
              profesional.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm flex flex-col items-center text-center" data-id="element-202">
            <div className="bg-amber-100 p-4 rounded-full mb-4" data-id="element-203">
              <HeartIcon size={32} className="text-amber-600" data-id="element-204" />
            </div>
            <h3 className="text-lg font-bold text-amber-900 mb-2" data-id="element-205">
              Amantes de la Pastelería
            </h3>
            <p className="text-gray-700" data-id="element-206">
              Amantes de la pastelería que buscan una receta auténtica y
              confiable.
            </p>
          </div>
        </div>
      </div>
    </section>;
}